import React from 'react'
import { connect } from '@cerebral/react'
import { css } from 'aphrodite'
import { signal } from 'cerebral/tags'
import styles from './styles'
import { Toggle } from './Toggle/'
import { Basket } from './Basket'
import { Attest } from './Attest'
import { t } from '@billes/translator-client'
import { Upload } from './Upload'

export default connect(
  {
    searchMedia: signal`media.searchMedia`
  },
  ({ searchMedia }) => {
    return (
      <div className={css(styles.navBar)}>
        <Toggle />
        <div className={css(styles.searchContainer)}>
          <input
            type={'text'}
            onKeyPress={e => {
              if (e.key === 'Enter') {
                searchMedia({ query: e.target.value })
              }
            }}
            className={css(styles.search)}
            placeholder={t('bms.header.searchPlaceholder')}
          />
          <div className={css(styles.searchIcon)}>
            <svg viewBox={'0 -15 512 512'}>
              <path
                d={
                  'm512 485l-147-147c31-38 47-82 47-132 0-57-20-106-60-146-41-40-89-60-146-60-57 0-106 20-146 60-40 40-60 89-60 146 0 57 20 105 60 146 40 40 89 60 146 60 50 0 94-16 132-47l147 147z m-490-279c0-51 18-94 54-130 36-36 79-54 130-54 51 0 94 18 130 54 36 36 54 79 54 130 0 51-18 94-54 130-36 36-79 54-130 54-51 0-94-18-130-54-36-36-54-79-54-130z'
                }
              />
            </svg>
          </div>
        </div>
        <div className={css(styles.actionContainer)}>
          <Basket />
          <Attest />
          <Upload />
        </div>
      </div>
    )
  }
)



// WEBPACK FOOTER //
// ./src/components/NavigationBar/navigationBar.js